import styled from 'styled-components'
import { theme } from "../theme";

const Container = styled.div<{ disabled?: boolean; }>`
  padding: ${theme.spacing.sm};
  font-weight: ${theme.typography.weights.extra};
  font-size: ${theme.typography.textSizes.sm};
  color: white;
  border-radius: 10px;
  text-align: center;
  width: 300px;
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  background-color: ${props => props.disabled ? 'grey' : theme.palette.primary};
  pointer-events: ${props => props.disabled ? 'none' : 'all'};
  box-sizing: border-box;
  transition: all 0.25s;
`

interface Props {
  onClick: () => void;
  label: React.ReactElement | string;
  disabled?: boolean;
}

export function Button(props: Props) {

  return (
    <Container disabled={props.disabled} onClick={props.onClick}>{props.label}</Container>
  )
}